import React from "react";
import { Carousel } from "react-responsive-carousel";

export default () => (

  <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false} >

    <a href="https://in.sugarcosmetics.com/collections/sugarnew">
      <div>
        <img alt="" src="https://in.sugarcosmetics.com/_next/image?url=https://d32baadbbpueqt.cloudfront.net/Homepage/36c0d566-1a7a-4fbd-9fbc-1ec0896d4dab.jpg&w=1080&q=75" width={'100%'}/>
      </div>
    </a>

    <a href="#">
      <div>
        <img alt="" src="https://in.sugarcosmetics.com/_next/image?url=https://d32baadbbpueqt.cloudfront.net/Homepage/0b8c0fe5-df30-49e1-99d4-6c193b407953.jpg&w=1080&q=75" width={'100%'}/>
      </div>
    </a>

    <a href="#">
      <div>
        <img alt="" src="https://in.sugarcosmetics.com/_next/image?url=https://d32baadbbpueqt.cloudfront.net/Homepage/639ef3ca-5c47-46b4-ac3e-9a96cbc71e5a.png&w=1080&q=75" width={'100%'}/>
      </div>
    </a>

    <a href="#">
      <div>
        <img alt="" src="https://in.sugarcosmetics.com/_next/image?url=https://d32baadbbpueqt.cloudfront.net/Homepage/d977001d-0ee7-4e48-8f4c-192cd655b7e1.jpg&w=1080&q=75" width={'100%'}/>
      </div>
    </a>

    <a href="#">
      <div>
        <img alt="" src="https://in.sugarcosmetics.com/_next/image?url=https://d32baadbbpueqt.cloudfront.net/Homepage/cfc6f6ac-7292-4eca-9ad8-cb5782ff3690.jpg&w=1080&q=75" width={'100%'}/>
      </div>
    </a>

    <a href="#">
      <div>
        <img alt="" src="https://in.sugarcosmetics.com/_next/image?url=https://d32baadbbpueqt.cloudfront.net/Homepage/4a98745d-d5a3-40b8-8277-215b8f537ad6.jpg&w=1080&q=75" width={'100%'}/>
      </div>
    </a>

    <a href="#">
      <div>
        <img alt="" src="https://in.sugarcosmetics.com/_next/image?url=https://d32baadbbpueqt.cloudfront.net/Homepage/03e68b85-10de-4a39-a515-06e48c8bd1c7.jpg&w=1080&q=75" width={'100%'}/>
      </div>
    </a>
    
  </Carousel>
  

);
